import { Component, Input, OnChanges, SimpleChange } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import hljs from 'highlight.js/lib/core';
// Import only the languages you need
import javascript from 'highlight.js/lib/languages/javascript';
import typescript from 'highlight.js/lib/languages/typescript';
import markdown from 'highlight.js/lib/languages/markdown';
import html from 'highlight.js/lib/languages/xml'; // HTML is treated as XML in highlight.js
import DOMPurify from 'dompurify';
import { Renderer, marked } from 'marked';

// Register the languages
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('typescript', typescript);
hljs.registerLanguage('markdown', markdown);
hljs.registerLanguage('html', html);

@Component({
  selector: 'app-markdown',
  templateUrl: './markdown.component.html'
})
export class MarkdownComponent implements OnChanges {

  @Input()
  text: string;
  @Input()
  showPreLine = true;

  data: SafeHtml;
  md: any;

  constructor(private sanitizer: DomSanitizer) {
    const renderer = new Renderer();
    renderer.code = this.highlightCode;
    this.md = marked.setOptions({ renderer });
  }

  highlightCode(code: string, language: string): string {
    if (!(language && hljs.getLanguage(language))) {
      // use 'markdown' as default language
      language = 'markdown';
    }

    const result = hljs.highlight(code, { language }).value;
    return `<code class="hljs ${language}">${result}</code>`;
  }

  markdownToSafeHtml(value: string): SafeHtml {
    const html = this.md(value);
    const safeHtml = DOMPurify.sanitize(html);
    return this.sanitizer.bypassSecurityTrustHtml(safeHtml);
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }): void {
    for (const propName in changes) {
      if (propName === 'text') {
        const value = changes[propName].currentValue;
        if (value) {
          this.data = this.markdownToSafeHtml(value);
        }
      }
    }
  }

}
